
import WebService from "../WebService"
const Accounting = {
    get_orders(params) {
        return WebService.get("/accounting/orders?" + params)
    },
    get_taxinvoices(params) {
        return WebService.get("/accounting/tax_invoices?" + params)
    },
}
export default Accounting